import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiHeaders } from './headers';
import { RestResponse } from '../model/io/api';
import { User } from '../model';
import { Pswd } from '../model/user';

@Injectable()
export class UserProvider {
  constructor(
    private http: HttpClient
  ) { }

  getMyProfile(): Observable<RestResponse> {
    return this.http.get<RestResponse>(`/api/user`, ApiHeaders.getOptions());
  }

  uploadProfilePhoto(imageFile: FormData): Observable<RestResponse> {
    return this.http.post<RestResponse>(`/api/user/pic`, imageFile);
  }

  getProfilePhoto(): Observable<any> {
    return this.http.get(`/api/user/pic`, ApiHeaders.getOptionsPlain());
  }

  deleteProfilePhoto(): Observable<any> {
    return this.http.delete(`/api/user/pic`);
  }

  updateMyDetails(user: User): Observable<RestResponse> {
    return this.http.post<RestResponse>(`/api/user/me`, user, ApiHeaders.getOptions());
  }

  changePassword(pswd: Pswd): Observable<RestResponse> {
    return this.http.post<RestResponse>(`/api/user/password`, pswd, ApiHeaders.getOptions());
  }

  addPromoForBroker(promo: string): Observable<RestResponse> {
    return this.http.post<RestResponse>(`/api/user/promo?code=${promo}`, null, ApiHeaders.getOptions());
  }

}
